export const noticeModals = {
  loginUpdate: {
    title: "Good News!",
    subtitle:
      "Now you can create a Bible Journey account so you can access your Bible plan from anywhere 🎉",
    firstButton: "I'll create my account later",
    secondButton: "Create account now",
  },
};
